// сделать явный импорт boot.js в editor, player, sandbox для наблюдаемости
import Vue from 'vue';
import VueImplicitCssModules from 'vue-implicit-css-modules';
import Static from './core/plugins/static';

Vue.use(VueImplicitCssModules);
Vue.use(Static);

// @WARNING Critical patch changing `provide` Vuejs 2.7 +
Vue.config.optionMergeStrategies.provide = Vue.config.optionMergeStrategies.data;
